import React from 'react'
import Navbar from '../Navbar/Navbar';
import './ExperiencedCA.css'
import ECA1 from './ECA1/ECA1';


const ExperiencedCA = () => {
  return (
    <div className='eca-container'>
      <Navbar/>
      <ECA1/>
    </div>
  )
}

export default ExperiencedCA ;
